import { __assign, __decorate, __extends, __rest } from "tslib";
import React from 'react';
import { Misc, Model, Utils } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import Scrollbar from 'react-custom-scrollbars';
import Collapsable from './Collapsable';
import { NeoReactTypes } from '../Modules/Types';
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        _this.expandState = new Model.ObservableValue(_this.props.initiallyCollapsed === undefined ? true : !_this.props.initiallyCollapsed);
        return _this;
    }
    Card.prototype.render = function () {
        var _a = this.props, icon = _a.icon, title = _a.title, children = _a.children, headerElements = _a.headerElements, useCustomScrollbar = _a.useCustomScrollbar, collapsible = _a.collapsible, initiallyCollapsed = _a.initiallyCollapsed, isExpanded = _a.isExpanded, domProps = __rest(_a, ["icon", "title", "children", "headerElements", "useCustomScrollbar", "collapsible", "initiallyCollapsed", "isExpanded"]);
        var className = Utils.joinWithSpaces("neo-card card", domProps.className);
        var isCollapsible = collapsible || isExpanded !== undefined || initiallyCollapsed !== undefined;
        var expandState = isExpanded !== null && isExpanded !== void 0 ? isExpanded : this.expandState;
        if (isCollapsible) {
            var expandIndicator = React.createElement("i", { onClick: function (e) { return expandState.value = !expandState.value; }, className: "card-expand-indicator fa fa-fw fa-angle-".concat(expandState.value ? "up" : "down") });
            if (headerElements) {
                headerElements = React.createElement(React.Fragment, null,
                    headerElements,
                    expandIndicator);
            }
            else {
                headerElements = expandIndicator;
            }
            if (!expandState.value) {
                className += " collapsed";
            }
            className += " card-collapsible";
        }
        var body = React.createElement("div", { className: "card-body" },
            useCustomScrollbar && React.createElement(Scrollbar, null, children),
            !useCustomScrollbar && children);
        if (isCollapsible) {
            body =
                React.createElement(Collapsable, { show: expandState.value }, body);
        }
        return (React.createElement("div", __assign({}, domProps, { className: className }),
            (icon || title) &&
                React.createElement("div", { className: "card-header", onClick: function (e) { return expandState.value = !expandState.value; } },
                    React.createElement("div", { className: "card-header-title" },
                        this.iconFactory.getIconComponent(icon),
                        React.createElement("span", null, title)),
                    headerElements && React.createElement("div", { className: "card-header-right-section", onClick: function (e) { return e.stopPropagation(); } }, headerElements)),
            body));
    };
    Card = __decorate([
        observer
    ], Card);
    return Card;
}(React.Component));
export default Card;
